<template>
  <div id="listPagination" class="list_pagination" style="display: flex; align-items: center;">
    <button type="button" id="btnPrevious" @click="prevPage" :disabled="pageNum === 1"></button>
    <div id="listNum">
      <div v-if="totalPages > 5">
        <button type="button" @click="goToPage($event, 1)" v-if="startPage > 1">1</button>
        <div v-if="startPage > 2" class="pagination-ellipsis">...</div>

        <button
            v-for="page in pageNumbers"
            :key="page"
            type="button"
            @click="goToPage($event, page)"
            :class="{ active: pageNum === page }"
        >
          {{ page }}
        </button>
        <div v-if="endPage < totalPages - 1" class="pagination-ellipsis">...</div>
        <button type="button" @click="goToPage($event, totalPages)" v-if="endPage < totalPages">{{ totalPages }}</button>
      </div>
      <div v-else>
        <button
            v-for="page in totalPages"
            :key="page"
            type="button"
            @click="goToPage($event, page)"
            :class="{ active: pageNum === page }"
        >
          {{ page }}
        </button>
      </div>
    </div>
    <button type="button" id="btnNext" @click="nextPage" :disabled="pageNum === totalPages"></button>
    <div class="go-to-page">
      <input type="number" v-model.number="inputPage" min="1" :max="totalPages" @keyup.enter="goToInputPage" />
      <button class="go-button" @click="goToInputPage">GO</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationUi',
  props: {
    totalItems: Number,
    itemsPerPage: Number,
    modelValue: Number
  },
  data() {
    return {
      pageNum: 1,
      maxVisible: 5,
      inputPage: null
    };
  },
  watch: {
    modelValue(newVal) {
      this.pageNum = newVal;
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    startPage() {
      let start = this.pageNum - Math.floor(this.maxVisible / 2);
      return Math.max(1, Math.min(start, this.totalPages - this.maxVisible + 1));
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisible - 1, this.totalPages);
    },
    pageNumbers() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    goToPage(event, page) {
      if (page !== this.pageNum) {
        this.pageNum = page;
        this.$emit('page-changed', page);
      }
    },
    prevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.$emit('page-changed', this.pageNum);
      }
    },
    nextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum++;
        this.$emit('page-changed', this.pageNum);
      }
    },
    goToInputPage() {
      if (this.inputPage >= 1 && this.inputPage <= this.totalPages) {
        this.goToPage(null, this.inputPage);
        this.inputPage = null;
      }
    }
  }
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
.pagination-ellipsis {
  display: inline-block;
  padding: 0 6px;
  color: #888;
}
.go-to-page {
  position: absolute;
  left: 300px;
  bottom: 0;
  display: inline-flex;
  align-items: center;
  margin: 0;
}
.go-to-page input {
  width: 50px;
  padding: 2px;
  margin-right: 4px;
}

.go-button {
  all: initial;
  background-color: #007bff;
  color: white;
  border: none;
  font-size: 14px;
  border-radius: 5px !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.go-button:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}
</style>
